import script from "./QuestionsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionsHeader.vue?vue&type=script&setup=true&lang=js"

import "./QuestionsHeader.vue?vue&type=style&index=0&id=6986bdc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6986bdc6"]])

export default __exports__